var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnssvgjs: "http://svgjs.com/svgjs",
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19.5 23.75c.5522 0 1-.4478 1-1v-10c0-.5522-.4478-1-1-1s-1 .4478-1 1v10c0 .5522.4478 1 1 1z",
    fill: "#000000",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.5 23.75c.5522 0 1-.4478 1-1v-10c0-.5522-.4478-1-1-1s-1 .4478-1 1v10c0 .5522.4478 1 1 1z",
    fill: "#000000",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20 4.25c.5522 0 1-.4478 1-1s-.4478-1-1-1h-8c-.5522 0-1 .4478-1 1s.4478 1 1 1z",
    fill: "#000000",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 5.25c-.5522 0-1 .4478-1 1s.4478 1 1 1h1v18.4c0 2.2599 1.84 4.1 4.1 4.1h11.8c2.2599 0 4.1-1.84 4.1-4.1v-18.4h1c.5522 0 1-.4478 1-1s-.4478-1-1-1h-2-18zm19 2v18.4c0 1.16-.94 2.1-2.1 2.1h-11.8c-1.16 0-2.1-.94-2.1-2.1v-18.4z",
    fill: "#000000",
    "data-original": "#000000"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.df5188feb246b90d4165848f505f2fb3.svg";
export { ForwardRef as ReactComponent };